import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import { API } from "../../Redux/actions/API";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import { useNavigate } from "react-router-dom";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Spinner from "../Spinner/Spinner";

function OnlineEpinRequestHistory() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let user = "";

  const [loader, setloader] = useState(false);
  const [TotalBet, setTotalBet] = useState("0");
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [search, setSearch] = useState(0);

  const referral_API = async () => {
    setloader(true);
    try {
      let responceRight = await API?.post(
        `EpinRequestHistory`,
        {
          uid: search,
          loginid: userId,
          type: "OnlineEpinRequestHistory",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );

      responceRight = responceRight?.data?.data[0];
      //console.log("res", responceRight);

      setleftreferralApi([]);
      let arrayLeft = [];
      let totalAmount = 0;

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          RowNumber: item?.row,
          uid: item?.uid,
          remark: item?.remark,
          utrno: (
            <a
              href={`https://bscscan.com/tx/${item?.upi_id_hash}`}
              target="_blank"
            >
              View
            </a>
          ),
          amount: `${item.amount}`,
          dd: item.requestedDate,
          client_txn_id: item?.client_txn_id,
          transid: item?.trnasid,
          ss:
            item.msg == "finished" ? (
              <span style={{ color: "green" }}>{item.msg}</span>
            ) : item.msg == "expired" ? (
              <span style={{ color: "orange" }}>{item.msg}</span>
            ) : (
              <span style={{ color: "red" }}>{item.msg}</span>
            ),
          ad: item.approveDate,
          epin_type: item.epin_type == "EpintypeB" ? "299" : "1000",
          epin_qty: item.epin_qty,
          epin_amount: item.epin_amount,
          epin_discountrate: item.epin_discountrate,
          epin_discountamount: item.epin_discountamount,
          epin_netamount: item.epin_netamount,
        });

        totalAmount = totalAmount + item.amount;
      });

      setleftreferralApi(arrayLeft);
      setTotalBet(totalAmount);
    } catch (error) {
      console.log("Error While calling Myteam API", error);
      if (
        error.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "" }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
    setloader(false);
  };

  const referral_API_Export = async () => {
    setloader(true);
    try {
      let responceRight = await API?.post(
        `EpinRequestHistory`,
        {
          uid: search,
          loginid: userId,
          type: "OnlineEpinRequestHistory",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      responceRight = responceRight?.data?.data[0];
      let arrayLeft = [];

      Array.isArray(responceRight) &&
        responceRight.forEach((item, index) => {
          arrayLeft.push({
            uid: item?.uid,
            utrno: (
              <a
                href={`https://bscscan.com/tx/${item?.upi_id_hash}`}
                target="_blank"
              >
                View
              </a>
            ),
            amount: `${item.amount}`,
            dd: item.requestedDate,
            client_txn_id: item?.client_txn_id,
            transid: item?.trnasid,
            ss:
              item.msg == "finished" ? (
                <span style={{ color: "green" }}>{item.msg}</span>
              ) : item.msg == "expired" ? (
                <span style={{ color: "orange" }}>{item.msg}</span>
              ) : (
                <span style={{ color: "red" }}>{item.msg}</span>
              ),
            ad: item.approveDate,
            epin_type: item.epin_type == "EpintypeB" ? "299" : "1000",
            epin_qty: item.epin_qty,
            epin_amount: item.epin_amount,
            epin_discountrate: item.epin_discountrate,
            epin_discountamount: item.epin_discountamount,
            epin_netamount: item.epin_netamount,
          });
        });

      const fileName = `OnlineEpinRequestHistory`;
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const ws = XLSX.utils.json_to_sheet(arrayLeft);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    } catch (error) {
      console.log("Error While calling Myteam API", error);
      if (
        error.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "" }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
    setloader(false);
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "RowNumber" },
      { Header: "User Id", accessor: "uid" },
      { Header: "Order Id", accessor: "client_txn_id" },

      { Header: "Epin Type", accessor: "epin_type" },
      { Header: "Quantity", accessor: "epin_qty" },
      { Header: "Req. Amount", accessor: "epin_amount" },

      { Header: "Discount Rate", accessor: "epin_discountrate" },
      { Header: "Discount Amount", accessor: "epin_discountamount" },
      { Header: "Net Amount (INR)", accessor: "epin_netamount" },
      { Header: "Net Amount (USDT)", accessor: "amount" },
      { Header: "Req. Date", accessor: "dd" },
      { Header: "Status", accessor: "ss" },
      { Header: "Paid Date", accessor: "ad" },
      //{ Header: "Txn Id", accessor: "transid" },
      { Header: "Txn Hash", accessor: "utrno" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div className="content-page">
        <div className="content">
          <div className="container">
            {/* <!-- Inline Form --> */}
            <div className="row">
              <div className="col-md-12">
                <div className="panel panel-primary">
                  <div className="panel-heading">
                    <h4 className="panel-title">Online EPIN Request History</h4>
                  </div>
                  <div
                    className="panel-body table-rep-plugin"
                    style={{ padding: "8px", overflowY: "scroll" }}
                  >
                    <div className="col-md-12">
                      <div className="row">
                        <form>
                          <div className="col-sm-3">
                            <input
                              type="text"
                              onChange={(e) => setSearch(e.target.value)}
                              value={search}
                              className="form-control"
                              placeholder="Enter User Id"
                              style={{ border: "1px solid silver" }}
                            />
                          </div>
                          <div className="col-sm-1">
                            <input
                              type="button"
                              id="btnsearch"
                              onClick={() => referral_API()}
                              className="btn btn-sm btn-primary"
                              value="Search"
                            />
                          </div>
                          <div className="col-sm-3">
                            <input
                              type="button"
                              id="btnsearch"
                              onClick={() => referral_API_Export()}
                              className="btn btn-sm btn-primary"
                              value="Export To Excel"
                            />
                          </div>
                        </form>
                        {/* <div
                          className="col-sm-4"
                          style={{ "margin-top": "10px" }}
                        >
                          <h4 className="panel-title">
                            Total Deposit Amount : {TotalBet}
                          </h4>
                        </div> */}
                      </div>

                      <div className="row">
                        <div className="panel-heading">
                          <h4 className="panel-title"></h4>
                        </div>
                        <div
                          className="table-responsive"
                          data-pattern="priority-columns"
                          style={{ maxHeight: "500px", overflow: "scroll" }}
                        >
                          <Table
                            data={currentPostleft}
                            columns={my_team.cols}
                          />

                          <Table_Buttons
                            indexOfFirstPage={indexOfFirstPage}
                            indexOfLastPost={indexOfLastPost}
                            setcurrentPage={setcurrentPage}
                            currentPage={currentPage}
                            totalData={leftreferralApi.length}
                            listPerpage={listPerpage}
                            handleRowsPerPageChange={setlistPerpage}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {loader && <Spinner />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OnlineEpinRequestHistory;
